import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {

  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined) return '';

    const bytes = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(bytes)) return '';

    // Less than 1KB
    if (bytes < 1024) {
      return `${bytes} بايت`;
    }

    const kb = bytes / 1024;
    if (kb < 1024) {
      return `${this.round(kb)} كيلوبايت`;
    }

    const mb = kb / 1024;
    if (mb < 1024) {
      return `${this.round(mb)} ميجابايت`;
    }

    const gb = mb / 1024;
    return `${this.round(gb)} جيجابايت`;
  }

  private round(num: number): string {
    // show up to 1 decimal if needed (e.g. 161.9)
    return num % 1 === 0 ? num.toString() : num.toFixed(1);
  }
}
